import {Component, OnDestroy, OnInit} from '@angular/core';
import {Response} from '@angular/http';
import {DomSanitizer} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

import {LoginResponse, UserService} from '../../api/user.service';
import {NotificationServiceBus} from '../../notification/notification.service';
import {User} from '../../shared/model/user.entity';
import {SpinnerService} from '../../spinner/spinner.service';
import {AuthGuard} from '../auth.guard';

@Component({
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  model: User = new User();
  private returnUrl = '';
  public vicDeafImg: boolean;

  errorMessage: string;

  insecurePassword = false;

  destroy$ = new Subject<void>();

  constructor(
    public spinnerService: SpinnerService,
    public notificationServiceBus: NotificationServiceBus,
    public service: UserService,
    public routes: ActivatedRoute,
    public router: Router,
    private domSanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.setImageBasedOnBusiness();
    if (AuthGuard.isLoggedIn()) {
      this.router.navigate(['booking-management']);
    }
    this.routes.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      // Defaults to 0 if no query param provided.
      this.returnUrl = params['returnUrl'] || '';
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

  private setImageBasedOnBusiness() {
    this.vicDeafImg =
      window.location.origin.toString() === 'https://auslanconnections.vicdeaf.com.au' ||
      window.location.origin.toString() === 'https://auslanconnections.expression.com.au';
  }

  onSubmit() {
    this.errorMessage = '';
    this.spinnerService.requestInProcess(true);
    localStorage.removeItem('token');
    this.service.login(this.model).subscribe(
      (res: LoginResponse) => {
        if ('token' in res.data) {
          this.model.token = res.data.token;
          AuthGuard.login(this.model);
          if ('has_new_password' in res.data && !res.data.has_new_password) {
            this.insecurePassword = true;
          } else if (res.data.has_temporary_password) {
            this.router.navigate(['/update-password'], { queryParams: { temporary: true }});
          }
          this.spinnerService.requestInProcess(false);
        } else if (res.data.jwt) {
          this.model.token = res.data.jwt;
          AuthGuard.login(this.model);
          this.router.navigate(['/dashboard'], {queryParams: {redirectedUrl: this.returnUrl}});
        }
      },
      (res: Response) => {
        let bodyJSON: any = {};
        try {
          bodyJSON = res.json();
        } catch (e) {}
        let errorMessage = 'Email or Password not found';

        if (res.status === 401) {
          const body: {errors: ''} = bodyJSON;
          if (typeof body.errors === 'string') {
            errorMessage = body.errors;
          }
        } else if (res.status === 404) {
          const body: {errors?: {remaining?: number}} = bodyJSON;
          const error = body.errors;
          if (error && error.remaining) {
            const ATTEMPT = 'attempt' + (error.remaining === 1 ? '' : 's');
            errorMessage += `, you have ${error.remaining} ${ATTEMPT} left after which you would be Locked out.`;
          }
        }

        this.spinnerService.requestInProcess(false);
        if (errorMessage.includes('you have entered an incorrect password')) {
          this.errorMessage = errorMessage;
          return;
        }
        this.notificationServiceBus.launchNotification(true, errorMessage);
      }
    );
  }

  changePassword() {
    // heck! to close modal properly by using setTimeout
    this.insecurePassword = false;
    setTimeout(() => this.router.navigate(['/update-password']));
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/login/login.component.ts